import { Aside, AsideType } from '@squareup/dex-ui';
import React, { FC, PropsWithChildren } from 'react';

function createCallout(asideType: AsideType): FC<PropsWithChildren> {
  const Callout: FC<PropsWithChildren> = ({ children }) => {
    return <Aside type={asideType}>{children}</Aside>;
  };
  Callout.displayName = `MdxCallout.${
    asideType.charAt(0).toUpperCase() + asideType.slice(1)
  }`;
  return Callout;
}

const Info = createCallout('info');
const Warning = createCallout('warning');
const Tip = createCallout('tip');
const Note = createCallout('info');
const Success = createCallout('success');

const MdxCallout = { Info, Warning, Tip, Note, Success };

export { MdxCallout };
